// StatusPill · Mandat (Lot M2)
// Affichage unifié du statut mandat (chemin nominal + closures).

const STATUS_META = {
  draft:              { label: "Brouillon",              dot: "#94A3B8", text: "text-black/70" },
  signed:             { label: "Signé",                  dot: "#38BDF8", text: "text-sky-700" },
  ready:              { label: "Prêt à commercialiser",  dot: "#F59E0B", text: "text-amber-700" },
  commercializing:    { label: "En commercialisation",   dot: "#C8FF2F", text: "text-black" },
  reserved:           { label: "Réservé",                dot: "#8B5CF6", text: "text-violet-700" },
  sold:               { label: "Vendu",                  dot: "#10B981", text: "text-emerald-700" },
  // Closures
  expired:            { label: "Échu",                   dot: "#64748B", text: "text-slate-600" },
  withdrawn:          { label: "Retiré",                 dot: "#64748B", text: "text-slate-600" },
  sold_by_seller:     { label: "Vendu (vendeur)",        dot: "#64748B", text: "text-slate-600" },
  sold_elsewhere:     { label: "Vendu (ailleurs)",       dot: "#64748B", text: "text-slate-600" },
  price_disagreement: { label: "Désaccord tarifaire",    dot: "#64748B", text: "text-slate-600" },
  agency_termination: { label: "Dénoncé (agence)",       dot: "#64748B", text: "text-slate-600" },
  abandoned:          { label: "Abandonné",              dot: "#64748B", text: "text-slate-600" },
  other:              { label: "Clôture · autre",        dot: "#64748B", text: "text-slate-600" },
};

export function statusMeta(status) {
  return STATUS_META[status] || STATUS_META.draft;
}

export default function StatusPill({ status, size = "md", className = "", testId }) {
  const meta = statusMeta(status);
  const isLg = size === "lg";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full ${isLg ? "px-3 py-1 text-[11px]" : "px-2.5 py-1 text-[10.5px]"} font-medium uppercase tracking-[0.16em] ${meta.text} ${className}`}
      style={{ background: "rgba(0,0,0,0.03)", boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.05)" }}
      data-testid={testId || `status-pill-${status}`}
    >
      <span className="h-[6px] w-[6px] rounded-full"
            style={{ background: meta.dot }} />
      {meta.label}
    </span>
  );
}
